import gql from 'graphql-tag'

export const DeclarationFragment = gql`
  fragment DeclarationFragment on Declaration {
    year
    id
    first_created_at
    updated_at
    function {
      name
      id
      description
    }
    items {
      id
      type
      function
      establishment {
        siren
        rna
        companyName
        entity
        address
        city
        postalCode
      }
    }
    partner {
      civility
      firstName
      lastName
      items {
        id
        type
        function
        establishment {
          siren
          rna
          companyName
          entity
          address
          city
          postalCode
        }
      }
    }
    children {
      civility
      firstName
      lastName
      familyRelationship {
        id
        name
      }
      familyRelationshipCustom
      items {
        id
        type
        function
        establishment {
          siren
          companyName
          entity
          address
          city
          postalCode
        }
      }
    }
  }
`
